// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b7628694","817":"c7d4ae52"}[chunkId] + ".chunk.js";
};